const MeterProvider = {
  0: 'Locus Energy',
  1: 'Also Energy',
  2: 'SolarEdge',
  3: 'MeteoControl',
  4: 'Power Factors'
};

export default MeterProvider;
